import EditFormGroup from "components/form/EditFormGroup";
import React, { forwardRef } from "react";

export default forwardRef(function RegisterForm(
  {
    data = {},
    onChange = () => {},
    // define onchange parameter 'state', 'event', 'name-value'
    type = "state",
  },
  ref
) {
  return (
    <div>
      <EditFormGroup
        ref={ref}
        data={data}
        onChange={onChange}
        type={type}
        layout={[
          {
            name: "name",
            placeholder: "Your Name",
            type: "text",
            required: true,
            startIcon: "PersonOutlined",
            itemSize: { lg: 12, md: 12, sm: 12, xs: 12 },
          },
          {
            name: "phone",
            placeholder: "Phone Number",
            type: "phone",
            required: true,
            startIcon: "PhoneOutlined",
            itemSize: { lg: 12, md: 12, sm: 12, xs: 12 },
          },
          {
            name: "email",
            placeholder: "E-mail address",
            type: "email",
            required: true,
            startIcon: "EmailOutlined",
            itemSize: { lg: 12, md: 12, sm: 12, xs: 12 },
          },
          {
            name: "password",
            placeholder: "Password",
            type: "password",
            required: true,
            startIcon: "LockOutlined",
            itemSize: { lg: 6, md: 6, sm: 6, xs: 6 },
          },
          {
            name: "password_confirm",
            placeholder: "Confirm",
            type: "password",
            required: true,
            startIcon: "LockOutlined",
            itemSize: { lg: 6, md: 6, sm: 6, xs: 6 },
          },
        ]}
        fullWidth={true}
        direction="row"
        spacing={2}
      />
    </div>
  );
});
